import { Path } from 'history';
import { scrollToTop } from '../../common/helpers/viewport';
import useRouter from './useRouter';
import { useIsBellaPageType } from './UrlManager/pageTypeHooks';

const useBellaPush = () => {
    const router = useRouter();
    const isBellaPageType = useIsBellaPageType();

    const bellaPush: NavigationPush = (to: Path) => {
        const { isBellaPage } = isBellaPageType(to);
        const isExternalLink = !isBellaPage;

        if (isExternalLink || router.disableClientsideNavigation) {
            window.location.assign(to);
            return;
        }

        scrollToTop();
        router.history.push(to);
    };

    return bellaPush;
};

export type NavigationPush = (to: Path) => void;

export default useBellaPush;
